import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ModalController, Platform } from '@ionic/angular';
import { AppLinksService } from 'src/app/services/applinks/app-links.service';

@Component({
  selector: 'app-external-link-content',
  templateUrl: './external-link-content.component.html',
  styleUrls: ['./external-link-content.component.scss'],
})

export class ExternalLinkContentComponent  implements OnInit {

  @Input() title:string = "";
  public iFrameURL: SafeResourceUrl | null;
  @Input() url:string;
  public isIOSApp:boolean;

  constructor(
    public viewCtrl: ModalController, 
    public sanitizer: DomSanitizer,
    public platform: Platform,
    public appLinks: AppLinksService,
    )
    {
      this.isIOSApp = this.platform.is("capacitor") && this.platform.is("ios");
    }

  ngOnInit(): void {
    this.iFrameURL = this.url ? this.sanitizer.bypassSecurityTrustResourceUrl(this.url) : null;
  }
  
  dismiss() {
    this.viewCtrl.dismiss();
  }

  openOutline() {
    this.appLinks.openInNewWindow( this.url );
  }
}